import React, { useState } from "react";
import { StrengthFinderProps } from "./StrengthFinder.types";
import {
  Container,
  ColorBar,
  Content,
  Title,
  Description,
  Toggle,
} from "./StrengthFinder.styles";

export const StrengthFinder: React.FC<StrengthFinderProps> = ({
  color,
  title,
  description,
}) => {
  const [isExpanded, setExpanded] = useState(false);

  const handleExpand = () => {
    setExpanded(!isExpanded);
  };

  return (
    <Container isExpanded={isExpanded}>
      <ColorBar color={color} />
      <Content>
        <Title>{title}</Title>
        <Description isExpanded={isExpanded}>
          {description}
          <Toggle onClick={handleExpand}>&nbsp;&nbsp;Show Less</Toggle>
        </Description>
        {isExpanded ? null : (
          <Toggle onClick={handleExpand}>&nbsp;&nbsp;Show More...</Toggle>
        )}
      </Content>
    </Container>
  );
};
